import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, Suspense as _Suspense, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63763be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-order-restock-table" }
const _hoisted_2 = {
  key: 0,
  class: "order-info"
}
const _hoisted_3 = { class: "order-info-title" }
const _hoisted_4 = { class: "order-info-content" }
const _hoisted_5 = { class: "order-info-item" }
const _hoisted_6 = { class: "order-info-item" }
const _hoisted_7 = { class: "order-info-item" }
const _hoisted_8 = { class: "order-info-content" }
const _hoisted_9 = { class: "order-info-item" }
const _hoisted_10 = { class: "confirm-order-table" }
const _hoisted_11 = { class: "order-table-title" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "flex-center product-info" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "line--2 fx-1" }
const _hoisted_16 = { class: "flex-ter" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"264px","font-size":"14px"} }, " これまでの「補充必要数」と「補充キャンセル数」の合計です。 ", -1))
const _hoisted_18 = { class: "flex-ter" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"264px","font-size":"14px"} }, " これまでに発生した、補充が必要な数量です。 ", -1))
const _hoisted_20 = { class: "flex-ter" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"264px","font-size":"14px"} }, " 一度補充されたものの、不良品・未納品などの理由により無効となった数量です。 ", -1))
const _hoisted_22 = { class: "quantity-input-number" }
const _hoisted_23 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_24 = { class: "line--3" }
const _hoisted_25 = ["onClick"]

import { montageAddition } from '@/util/calcAdt'
import STable from '@/components/Table/index.vue'
import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { ElMessage } from 'element-plus'
import { editOrderGoodsAdditionApi } from '@/apis/order'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { PlatformOrderItemRespDTO } from '@/service/order'
import { request } from '@/config/request/interceptors'
import { QuestionFilled } from '@element-plus/icons-vue'
import confirmDialog from '@/components/common/ConfirmDialog'

export default /*#__PURE__*/_defineComponent({
  props: ['loading', 'order', 'hiddenOrderInfo'],
  emits: ['refreshData'],
  setup(__props, { emit: emits }) {

const props = __props


const columns = [
  {
    label: t('序号'),
    prop: 'index',
    align: 'center',
    slotName: 'index',
    width: 100
  },
  {
    label: t('商品名称'),
    prop: 'productTitle',
    slotName: 'productTitle',
    align: 'center',
    width: 160
  },
  {
    label: t('商品属性'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('客户SKU'),
    prop: 'customerProductSku',
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionList',
    align: 'center',
    slotName: 'platformOrderItemAdditionList',
    width: 160
  },
  {
    label: t('商品单价'),
    prop: 'actualPrice',
    align: 'center'
  },
  {
    label: t('小计'),
    prop: 'actualTotalPrice',
    align: 'center'
  },
  {
    label: t('建议补货数量'),
    prop: 'quantity',
    align: 'center',
    slotName: 'quantity',
    slotHeadName: 'quantityHead',
    width: 140
  },
  {
    label: t('历史需补货数'),
    prop: 'historyReplenishQuantity',
    slotHeadName: 'historyReplenishQuantityHead',
    align: 'center'
  },
  {
    label: t('被取消需补货数'),
    prop: 'cancelReplenishQuantity',
    slotHeadName: 'cancelReplenishQuantityQuantityHead',
    align: 'center'
  }
]
const goodsAdditionList: any = ref(null)
const goodsRowItem: any = ref({})
const openAddition = (row: any, order: any) => {

  isBatch.value = false
  goodsRowItem.value = {
    ...row,
    platformOrderItemAdditionDTOList: (row.platformOrderItemAdditionList === '-' ? [] : row.platformOrderItemAdditionList ?? [])?.map((item: any) => {
      return {
        ...item,
        washedlabelSpecification:
          item.washedlabelSpecification === '-'
            ? null
            : item.washedlabelSpecification,
        spotCheckRatio: item.spotCheckRatio && item.spotCheckRatio !== '-' ? item.spotCheckRatio : ''
      }
    })
  }
  goodsAdditionList.value = row.platformOrderItemAdditionList?.map((item: any) => {
    return {
      ...item,
      washedlabelSpecification: item.washedlabelSpecification === '-' ? null : item.washedlabelSpecification
    }
  }) ?? []
}
const noAdd = (row:any) => {
  goodsRowItem.value = row
  handleAdt(1)
}

const handleAdt = (adt: any) => {
  editOrderGoodsAdditionApi({
    platformOrderId: props.order?.platformOrderId,
    platformOrderItemIdList: isBatch.value ? selectList.value.map(v => v.platformOrderItemId) : [goodsRowItem.value.platformOrderItemId],
    cartAdditionList:
      adt === 1
        ? []
        : adt.map((i: any) => {
          return {
            shopProductSku: goodsRowItem.value.shopProductSku,
            additionConfigId: i.additionConfigId,
            additionId: i.additionId,
            ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
            additionExtraName: i.additionExtraName,
            washedlabelAdditionId:
              i.washedlabelAdditionId === '-' ? '' : i.washedlabelAdditionId,
            washedlabelSpecification:
              i.washedlabelSpecification === '-'
                ? null
                : i.washedlabelSpecification,
            spotCheckRatio: i.spotCheckRatio && i.spotCheckRatio !== '-' ? i.spotCheckRatio : '',
            spotCheckFlag: i.spotCheckFlag
          }
        }),
    noAdditionalFlag: adt === 1 ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      emits('refreshData')
    }
  })
}
const selectList = ref([])
const isBatch = ref(false)
const handleSelectionChange = (value) => {
  console.log(value)
  selectList.value = value
}
const batchEditAddition = () => {
  if (selectList.value.length === 0) {
    ElMessage.success(t('请勾选'))
    return
  }
  isBatch.value = true
  goodsRowItem.value = {}
  goodsAdditionList.value = []
}

const changeRecommendReplenishQuantity = async (row: PlatformOrderItemRespDTO, min:number) => {
  console.log('row?.recommendReplenishQuantity', row?.recommendReplenishQuantity)
  if ((!row?.recommendReplenishQuantity && row?.recommendReplenishQuantity !== 0) || isNaN(row?.recommendReplenishQuantity) || (Number(row.recommendReplenishQuantity) === 0 && min === 1)) {
    row.recommendReplenishQuantity = 1
  }
  if (Number(row.recommendReplenishQuantity) === 0) {
    await confirmDialog({
      title: t('提示'),
      text: 'このSKUを補充リストから削除してもよろしいですか？<br/>削除後、該当SKUを含む未出荷の直送注文がある場合は、手動でカートから補充依頼を作成する必要があります。',
      htmlNode: true,
      okText: t('确认'),
      cancelText: t('取消'),
      onCancel: () => {
        emits('refreshData')
      }
    })
  }
  const res = await request.order.customer.platformOrderEditRecommendReplenishQuantity({
    platformOrderItemId: row.platformOrderItemId,
    recommendReplenishQuantity: row.recommendReplenishQuantity
  })
  if (res.success) {
    ElMessage.success(t('修改成功'))
  }
  emits('refreshData')
}
const changeInput = (row:any) => {
  row.recommendReplenishQuantity = row.recommendReplenishQuantity?.replace(/[^\d]/g, '');
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.hiddenOrderInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('订单详情')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(__props.order.platformOrderNo), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('客户订单编号')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(__props.order.customerOrderNo || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('下单时间')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(__props.order.createTime || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('采购国家')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(__props.order.goodsCountry === 'CN' ? '中国' : '') + _toDisplayString(__props.order.goodsCountry === 'JP' ? '日本' : ''), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(__props.hiddenOrderInfo ? _unref(t)('商品信息') : _unref(t)('确认订单信息')), 1),
          _createElementVNode("a", {
            class: "btn",
            onClick: batchEditAddition
          }, _toDisplayString(_unref(t)('批量编辑商品附加项')), 1)
        ]),
        _createVNode(STable, {
          tableData: __props.order.platformOrderItems,
          columns: columns,
          showPagination: false,
          ref: (_value, _refs) => {
            _refs['table'] = _value
          },
          tableConfig: {
          showSelection: true,
        },
          onSelectionChange: handleSelectionChange
        }, {
          index: _withCtx(({ rowIndex }) => [
            _createTextVNode(_toDisplayString(rowIndex + 1), 1)
          ]),
          productTitle: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: row.productSkuImg,
                alt: "",
                style: {"width":"46px","height":"46px"}
              }, null, 8, _hoisted_14),
              _createElementVNode("span", _hoisted_15, _toDisplayString(row.productTitle), 1)
            ])
          ]),
          quantityHead: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(_toDisplayString(_unref(t)('建议补货数量')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_17
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          historyReplenishQuantityHead: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_18, [
              _createTextVNode(_toDisplayString(_unref(t)('历史需补货数')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_19
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          cancelReplenishQuantityQuantityHead: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_20, [
              _createTextVNode(_toDisplayString(_unref(t)('被取消需补货数')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _hoisted_21
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    color: "#999",
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          quantity: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_input, {
                precision: 0,
                size: "small",
                modelValue: row.recommendReplenishQuantity,
                "onUpdate:modelValue": ($event: any) => ((row.recommendReplenishQuantity) = $event),
                onBlur: ($event: any) => (changeRecommendReplenishQuantity(row, __props.order.platformOrderItems?.length > 1 ? 0 : 1)),
                onInput: ($event: any) => (changeInput(row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"])
            ])
          ]),
          platformOrderItemAdditionList: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionList)), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionList)), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", null, [
              _withDirectives(_createVNode(_component_el_radio, {
                "model-value": row.noAdditionalFlag === 1,
                size: "small",
                label: true,
                style: {"margin-right":"0"},
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                onChange: ($event: any) => (noAdd(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "onChange"]), [
                [_vShow, (!row.platformOrderItemAdditionList?.length || row.platformOrderItemAdditionList === '-')]
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (openAddition(row)), ["stop"])
                }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_25)
              ]),
              _withDirectives(_createElementVNode("div", { class: "add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                [_vShow, (!row.platformOrderItemAdditionList && row.noAdditionalFlag !== 1)]
              ])
            ])
          ]),
          _: 1
        }, 8, ["tableData"])
      ], 512), [
        [_directive_loading, __props.loading]
      ])
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (goodsAdditionList.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: goodsAdditionList.value,
              "onUpdate:list": _cache[1] || (_cache[1] = ($event: any) => ((goodsAdditionList).value = $event)),
              onCommit: handleAdt,
              type: "AdtOrder",
              proxy: goodsRowItem.value,
              countryCode: "CN",
              noSpot: goodsRowItem.value?.orderQuantity === 1
            }, null, 8, ["list", "proxy", "noSpot"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 64))
}
}

})